
<table>
  <tr>
    <td *ngIf="showTitle && reportReportElement != null && reportReportElement.DisplayName">
      <div  style="padding: 7px 15px 7px 7px;">
        <div style="font-size: 20px; font-weight: bold; white-space: nowrap;">
          {{reportReportElement.Name}}
        </div>
        <div style="font-size: 13px; font-style: italic; white-space: nowrap;">{{reportReportElement.Description != null ? reportReportElement.Description : ''}}</div>
      </div>
    </td>
    <td style="padding-left: 15px; padding-bottom: 7px; padding-top: 5px; vertical-align: bottom;">
      <div style="white-space: nowrap; font-size: 12px;">{{reportReportElement?.StartDateFormattedLong}}</div>
    </td>
    <td style="padding: 0 5px 0 5px; padding-bottom: 7px; padding-top: 5px; vertical-align: bottom;">
      {{reportReportElement != null ? '-' : ''}}
    </td>
    <td style="padding-bottom: 7px; padding-top: 5px; vertical-align: bottom; ">
      <div style="white-space: nowrap; font-size: 12px;">{{reportReportElement?.EndDateFormattedLong}}</div>
    </td>
  </tr>
</table>


<table>
  <tr>
    <td style="vertical-align: top;">
      <div class="mat-elevation-z5">
        <dx-data-grid class=" negative-margin-top_ "
                      [width]="rawDataGridWidth"
                      [height]="rawDataGridHeight"
                      noDataText=""
                      [columnAutoWidth]="true"
                      [dataSource]="rawDataGridDataSource"
                      keyExpr="ProductionRawDataId"
                      [hoverStateEnabled]="true"
                      [rowAlternationEnabled]="true"
                      (onInitialized)="rawDataGridItialized($event)">

          <dxo-load-panel [enabled]="true"></dxo-load-panel>
          <dxo-scrolling [scrollByContent]="true" showScrollbar="always"></dxo-scrolling>
          <dxo-paging [enabled]="false"></dxo-paging>
          <dxo-filter-row [visible]="true"></dxo-filter-row>

          <dxi-column dataField="OrderNumber" [fixed]="true" caption="{{ls.LNG('Label.OrderNumber')}}"></dxi-column>
          <dxi-column dataField="OrderLineNumber2" [fixed]="true" calculateDisplayValue="OrderLineNumber" caption="{{ls.LNG('Label.Line')}}"></dxi-column>
          <dxi-column dataField="StatusName" caption="{{ls.LNG('Label.Status')}}"></dxi-column>
          <dxi-column dataField="OrderDetails" caption="{{ls.LNG('Label.Details')}}"></dxi-column>
          <dxi-column dataField="ProductionDetails" caption="{{ls.LNG('Label.ProductionDetails')}}"></dxi-column>
          <dxi-column dataField="ArticleNumber" caption="{{ls.LNG('Label.Article')}}"></dxi-column>
          <dxi-column dataField="NumberProducts" caption="{{ls.LNG('Label.Products')}}"></dxi-column>
          <dxi-column dataField="NumberToDo" caption="{{ls.LNG('Label.NUmberToDo')}}"></dxi-column>
          <dxi-column dataField="NumberDone" caption="{{ls.LNG('Label.NumberDone')}}"></dxi-column>
          <dxi-column dataField="ProductionTime_inSeconds" caption="{{ls.LNG('Label.ProductionTimes')}}"></dxi-column>

          <dxo-summary [calculateCustomSummary]="calculateRawDataGridSummary">
            <dxi-total-item name="OrderNumber"
                            column="OrderNumber"
                            [customizeText]="rawDataGridOrderNumberText"
                            summaryType="custom">
            </dxi-total-item>
            <dxi-total-item name="OrderLineNumber"
                            column="OrderLineNumber2"
                            [customizeText]="rawDataGridOrderLineNumberText"
                            summaryType="custom">
            </dxi-total-item>
            <dxi-total-item name="NumberProducts"
                            column="NumberProducts"
                            [customizeText]="rawDataGridOrderProductsText"
                            summaryType="custom">
            </dxi-total-item>
            <dxi-total-item name="ProductionTime_inSeconds"
                            column="ProductionTime_inSeconds"
                            [customizeText]="rawDataGridProductionTime_inSecondsText"
                            summaryType="custom">
            </dxi-total-item>
          </dxo-summary>

        </dx-data-grid>
      </div>
    </td>
    <td style="vertical-align: top; padding-left: 15px;">
      <div class="mat-elevation-z5">
        <dx-data-grid class=" negative-margin-top_ "
                      [width]="productionDataGridWidth"
                      [height]="productionDataGridHeight"
                      [columns]="productionDataGridColumns"
                      noDataText=""
                      columnMinWidth="130"
                      [columnAutoWidth]="true"
                      [dataSource]="productionDataGridDataSource"
                      keyExpr="ProductionDataId"
                      [hoverStateEnabled]="true"
                      [rowAlternationEnabled]="true"
                      (onCellClick)="productionDataGridCellClick($event)"
                      (onCellPrepared)="productionDataGridCellPrepared($event)"
                      (onRowPrepared)="productionDataGridRowPrepared($event)"
                      (onInitialized)="productionDataGridItialized($event)">

          <dxo-load-panel [enabled]="true"></dxo-load-panel>
          <dxo-scrolling [scrollByContent]="true" showScrollbar="always"></dxo-scrolling>
          <dxo-sorting mode="none"></dxo-sorting>
          <dxo-paging [enabled]="false"></dxo-paging>

          <dxo-summary [calculateCustomSummary]="productionDataGridSummary" [totalItems]="productionDataGridSummaryTotalItems">
          </dxo-summary>

          <div *dxTemplate="let d of 'theCellTemplate0'">
            <div [style.padding]="d.rowType === 'data' ? '0px 5px 0px 5px' : ''" [style.color]="!d.data.IsWorkday ? '#de2222' : 'inherit'">{{d.data.DateFormatted}}</div>
          </div>

          <div *dxTemplate="let d of 'theCellTemplate'">
            <div *ngIf="d.value != null && d.value.NumberToDo > 0">
              <app-ams-progress-bar width="100" height="65"
                                    [valueText1]="ls.LNG('Label.Load')" [value1]="d.value.PercentageWorkload"
                                    [valueText2]="ls.LNG('Label.Completed')" [value2]="d.value.PercentageDone">
              </app-ams-progress-bar>
            </div>
          </div>
        </dx-data-grid>
      </div>
    </td>
  </tr>
</table>
